'use client';

import Cookies from 'js-cookie';
import { apiCall } from '../helper/common_helper';

export const loginUser = async (credentials : any) => {
    const response = await apiCall('POST', 'auth/login', credentials);
    if (response) {
        const data = response.data;
        if (response.status === 201) {
            Cookies.set('accessToken', data.accessToken, { expires: 1, secure: true, sameSite: 'strict' });
            return data;
        } else {
            throw new Error(data.message || 'Login failed');
        }
    }
};

export const logoutUser = async () => {
    Cookies.remove('accessToken');
};

export const getToken = () => {
    if (typeof window !== 'undefined') {
        return Cookies.get('accessToken');
    }
    return null;
};